export default "__VITE_ASSET__DfIkqEVE__"